import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import type {TextColumnModel} from '../../../../../models/column-model/custom/text'
import type {ClipboardContent} from '../types'

export const buildTextUpdateFromClipboardContent = (content: ClipboardContent | string, column: TextColumnModel) => {
  return {
    dataType: MemexColumnDataType.Text,
    memexProjectColumnId: column.id,
    value: typeof content === 'string' ? content : content.text,
  }
}
